// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MailCartShipmentMethod,
    ObjectNoResponse,
    ProviderMail,
    ProviderMailCart,
    ProviderMailCartSortType,
    ProviderMailSortType,
    SupportAssignMailPayload,
    SupportCreateMailCartPayload,
    SupportCreateMailCartShipmentPayload,
    SupportGetMailCartAvailableMethods,
    SupportMail,
    SupportMailCart,
    SupportMailCartSortType,
    SupportMailSortType,
    SupportAssignMailPayloadToJSON,
    SupportCreateMailCartPayloadToJSON,
    SupportCreateMailCartShipmentPayloadToJSON,
    SupportGetMailCartAvailableMethodsToJSON,
    MailCartShipmentMethodFromJSON,
    ObjectNoResponseFromJSON,
    ProviderMailFromJSON,
    ProviderMailCartFromJSON,
    SupportMailFromJSON,
    SupportMailCartFromJSON,
} from '../models';

export interface AddSupportMailToMailCartRequest {
    cid: string;
    mid: string;
}

export interface AssignSupportMailRequest {
    id: string;
    supportAssignMailPayload: SupportAssignMailPayload;
}

export interface CreateSupportMailCartRequest {
    supportCreateMailCartPayload: SupportCreateMailCartPayload;
}

export interface CreateSupportMailCartShipmentRequest {
    id: string;
    supportCreateMailCartShipmentPayload: SupportCreateMailCartShipmentPayload;
}

export interface DisableSupportMailCartRequest {
    id: string;
}

export interface GetProviderMailRequest {
    id: string;
}

export interface GetProviderMailCartRequest {
    id: string;
}

export interface GetSupportMailRequest {
    id: string;
}

export interface GetSupportMailCartRequest {
    id: string;
}

export interface GetSupportMailCartAvailableMethodsRequest {
    id: string;
    supportGetMailCartAvailableMethods: SupportGetMailCartAvailableMethods;
}

export interface ListProviderMailRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderMailOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterOcr?: Array<string>;
    filterReceived?: Array<string>;
    filterPages?: Array<string>;
    sort?: Array<ProviderMailSortType>;
}

export interface ListProviderMailCartsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderMailCartsOrderEnum>;
    filterCreated?: Array<string>;
    filterName?: Array<string>;
    filterShipped?: string;
    sort?: Array<ProviderMailCartSortType>;
}

export interface ListSupportMailRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportMailOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterExternalId?: Array<string>;
    filterBarcode?: Array<string>;
    filterAssigned?: Array<string>;
    filterOcr?: Array<string>;
    filterReceived?: Array<string>;
    filterPages?: Array<string>;
    sort?: Array<SupportMailSortType>;
}

export interface ListSupportMailCartsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportMailCartsOrderEnum>;
    filterCreated?: Array<string>;
    filterName?: Array<string>;
    filterActive?: string;
    filterShipped?: string;
    sort?: Array<SupportMailCartSortType>;
}

export interface RemoveSupportMailToMailCartRequest {
    cid: string;
    mid: string;
}

export interface UnassignSupportMailRequest {
    id: string;
}

/**
 * no description
 */
export class MailApi extends runtime.BaseAPI {

    /**
     * Create a Mail cart
     * Add a Mail to a Mail cart
     */
    async addSupportMailToMailCartRaw(requestParameters: AddSupportMailToMailCartRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling addSupportMailToMailCart.');
        }

        if (requestParameters['mid'] === null || requestParameters['mid'] === undefined) {
            throw new runtime.RequiredError('mid','Required parameter requestParameters.mid was null or undefined when calling addSupportMailToMailCart.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:mail", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/cart/{cid}/mail/{mid}`.replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))).replace(`{${"mid"}}`, encodeURIComponent(String(requestParameters.mid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Create a Mail cart
     * Add a Mail to a Mail cart
     */
    async addSupportMailToMailCart(requestParameters: AddSupportMailToMailCartRequest): Promise<ObjectNoResponse> {
        const response = await this.addSupportMailToMailCartRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create and send a letter in the mail.
     * Assigns the mail
     */
    async assignSupportMailRaw(requestParameters: AssignSupportMailRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling assignSupportMail.');
        }

        if (requestParameters['supportAssignMailPayload'] === null || requestParameters['supportAssignMailPayload'] === undefined) {
            throw new runtime.RequiredError('supportAssignMailPayload','Required parameter requestParameters.supportAssignMailPayload was null or undefined when calling assignSupportMail.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:mail", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/{id}/assign`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportAssignMailPayloadToJSON(requestParameters['supportAssignMailPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Create and send a letter in the mail.
     * Assigns the mail
     */
    async assignSupportMail(requestParameters: AssignSupportMailRequest): Promise<ObjectNoResponse> {
        const response = await this.assignSupportMailRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a Mail cart.
     * Create a Mail cart
     */
    async createSupportMailCartRaw(requestParameters: CreateSupportMailCartRequest): Promise<runtime.ApiResponse<SupportMailCart>> {
        if (requestParameters['supportCreateMailCartPayload'] === null || requestParameters['supportCreateMailCartPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateMailCartPayload','Required parameter requestParameters.supportCreateMailCartPayload was null or undefined when calling createSupportMailCart.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:mail", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/cart`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateMailCartPayloadToJSON(requestParameters['supportCreateMailCartPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportMailCartFromJSON(jsonValue));
    }

    /**
     * Create a Mail cart.
     * Create a Mail cart
     */
    async createSupportMailCart(requestParameters: CreateSupportMailCartRequest): Promise<SupportMailCart> {
        const response = await this.createSupportMailCartRaw(requestParameters);
        return await response.value();
    }

    /**
     * Ship an unshipped Mail cart
     * Ship an unshipped Mail cart
     */
    async createSupportMailCartShipmentRaw(requestParameters: CreateSupportMailCartShipmentRequest): Promise<runtime.ApiResponse<SupportMailCart>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportMailCartShipment.');
        }

        if (requestParameters['supportCreateMailCartShipmentPayload'] === null || requestParameters['supportCreateMailCartShipmentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateMailCartShipmentPayload','Required parameter requestParameters.supportCreateMailCartShipmentPayload was null or undefined when calling createSupportMailCartShipment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/cart/{id}/ship`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateMailCartShipmentPayloadToJSON(requestParameters['supportCreateMailCartShipmentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportMailCartFromJSON(jsonValue));
    }

    /**
     * Ship an unshipped Mail cart
     * Ship an unshipped Mail cart
     */
    async createSupportMailCartShipment(requestParameters: CreateSupportMailCartShipmentRequest): Promise<SupportMailCart> {
        const response = await this.createSupportMailCartShipmentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an unshipped Mail cart
     * Disable an unshipped Mail cart
     */
    async disableSupportMailCartRaw(requestParameters: DisableSupportMailCartRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportMailCart.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/cart/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an unshipped Mail cart
     * Disable an unshipped Mail cart
     */
    async disableSupportMailCart(requestParameters: DisableSupportMailCartRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportMailCartRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a piece of mail
     * Get a piece of mail
     */
    async getProviderMailRaw(requestParameters: GetProviderMailRequest): Promise<runtime.ApiResponse<ProviderMail>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderMail.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/mail/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderMailFromJSON(jsonValue));
    }

    /**
     * Get a piece of mail
     * Get a piece of mail
     */
    async getProviderMail(requestParameters: GetProviderMailRequest): Promise<ProviderMail> {
        const response = await this.getProviderMailRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a Mail cart
     * Get a Mail cart
     */
    async getProviderMailCartRaw(requestParameters: GetProviderMailCartRequest): Promise<runtime.ApiResponse<ProviderMailCart>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderMailCart.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/mail/cart/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderMailCartFromJSON(jsonValue));
    }

    /**
     * Gets a Mail cart
     * Get a Mail cart
     */
    async getProviderMailCart(requestParameters: GetProviderMailCartRequest): Promise<ProviderMailCart> {
        const response = await this.getProviderMailCartRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a piece of mail
     * Get a piece of mail
     */
    async getSupportMailRaw(requestParameters: GetSupportMailRequest): Promise<runtime.ApiResponse<SupportMail>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportMail.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail", "support", "support:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportMailFromJSON(jsonValue));
    }

    /**
     * Get a piece of mail
     * Get a piece of mail
     */
    async getSupportMail(requestParameters: GetSupportMailRequest): Promise<SupportMail> {
        const response = await this.getSupportMailRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a Mail cart
     * Get a Mail cart
     */
    async getSupportMailCartRaw(requestParameters: GetSupportMailCartRequest): Promise<runtime.ApiResponse<SupportMailCart>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportMailCart.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/cart/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportMailCartFromJSON(jsonValue));
    }

    /**
     * Gets a Mail cart
     * Get a Mail cart
     */
    async getSupportMailCart(requestParameters: GetSupportMailCartRequest): Promise<SupportMailCart> {
        const response = await this.getSupportMailCartRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a Mail cart\'s available shipment methods
     * Get a Mail cart\'s available shipment methods
     */
    async getSupportMailCartAvailableMethodsRaw(requestParameters: GetSupportMailCartAvailableMethodsRequest): Promise<runtime.ApiResponse<Array<MailCartShipmentMethod>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportMailCartAvailableMethods.');
        }

        if (requestParameters['supportGetMailCartAvailableMethods'] === null || requestParameters['supportGetMailCartAvailableMethods'] === undefined) {
            throw new runtime.RequiredError('supportGetMailCartAvailableMethods','Required parameter requestParameters.supportGetMailCartAvailableMethods was null or undefined when calling getSupportMailCartAvailableMethods.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/cart/{id}/available_methods`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportGetMailCartAvailableMethodsToJSON(requestParameters['supportGetMailCartAvailableMethods']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailCartShipmentMethodFromJSON));
    }

    /**
     * Gets a Mail cart\'s available shipment methods
     * Get a Mail cart\'s available shipment methods
     */
    async getSupportMailCartAvailableMethods(requestParameters: GetSupportMailCartAvailableMethodsRequest): Promise<Array<MailCartShipmentMethod>> {
        const response = await this.getSupportMailCartAvailableMethodsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of mail
     * Get a list of mail
     */
    async listProviderMailRaw(requestParameters: ListProviderMailRequest): Promise<runtime.ApiResponse<Array<ProviderMail>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterOcr) {
            queryParameters['filterOcr'] = requestParameters.filterOcr;
        }

        if (requestParameters.filterReceived) {
            queryParameters['filterReceived'] = requestParameters.filterReceived;
        }

        if (requestParameters.filterPages) {
            queryParameters['filterPages'] = requestParameters.filterPages;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/mail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderMailFromJSON));
    }

    /**
     * Gets a list of mail
     * Get a list of mail
     */
    async listProviderMail(requestParameters: ListProviderMailRequest): Promise<Array<ProviderMail>> {
        const response = await this.listProviderMailRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of Mail carts
     * Get a list of Mail carts
     */
    async listProviderMailCartsRaw(requestParameters: ListProviderMailCartsRequest): Promise<runtime.ApiResponse<Array<ProviderMailCart>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterShipped !== undefined) {
            queryParameters['filterShipped'] = requestParameters.filterShipped;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/mail/cart`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderMailCartFromJSON));
    }

    /**
     * Gets a list of Mail carts
     * Get a list of Mail carts
     */
    async listProviderMailCarts(requestParameters: ListProviderMailCartsRequest): Promise<Array<ProviderMailCart>> {
        const response = await this.listProviderMailCartsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of mail
     * Get a list of mail
     */
    async listSupportMailRaw(requestParameters: ListSupportMailRequest): Promise<runtime.ApiResponse<Array<SupportMail>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterBarcode) {
            queryParameters['filterBarcode'] = requestParameters.filterBarcode;
        }

        if (requestParameters.filterAssigned) {
            queryParameters['filterAssigned'] = requestParameters.filterAssigned;
        }

        if (requestParameters.filterOcr) {
            queryParameters['filterOcr'] = requestParameters.filterOcr;
        }

        if (requestParameters.filterReceived) {
            queryParameters['filterReceived'] = requestParameters.filterReceived;
        }

        if (requestParameters.filterPages) {
            queryParameters['filterPages'] = requestParameters.filterPages;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportMailFromJSON));
    }

    /**
     * Gets a list of mail
     * Get a list of mail
     */
    async listSupportMail(requestParameters: ListSupportMailRequest): Promise<Array<SupportMail>> {
        const response = await this.listSupportMailRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of Mail carts
     * Get a list of Mail carts
     */
    async listSupportMailCartsRaw(requestParameters: ListSupportMailCartsRequest): Promise<runtime.ApiResponse<Array<SupportMailCart>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterShipped !== undefined) {
            queryParameters['filterShipped'] = requestParameters.filterShipped;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:mail", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/cart`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportMailCartFromJSON));
    }

    /**
     * Gets a list of Mail carts
     * Get a list of Mail carts
     */
    async listSupportMailCarts(requestParameters: ListSupportMailCartsRequest): Promise<Array<SupportMailCart>> {
        const response = await this.listSupportMailCartsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Remove a Mail cart
     * Remove a Mail from a Mail cart
     */
    async removeSupportMailToMailCartRaw(requestParameters: RemoveSupportMailToMailCartRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling removeSupportMailToMailCart.');
        }

        if (requestParameters['mid'] === null || requestParameters['mid'] === undefined) {
            throw new runtime.RequiredError('mid','Required parameter requestParameters.mid was null or undefined when calling removeSupportMailToMailCart.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:mail", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/cart/{cid}/mail/{mid}`.replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))).replace(`{${"mid"}}`, encodeURIComponent(String(requestParameters.mid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Remove a Mail cart
     * Remove a Mail from a Mail cart
     */
    async removeSupportMailToMailCart(requestParameters: RemoveSupportMailToMailCartRequest): Promise<ObjectNoResponse> {
        const response = await this.removeSupportMailToMailCartRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unassigns a mail piece from the user.
     * Unassigns the mail to the granted user
     */
    async unassignSupportMailRaw(requestParameters: UnassignSupportMailRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unassignSupportMail.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:mail", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/mail/{id}/unassign`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Unassigns a mail piece from the user.
     * Unassigns the mail to the granted user
     */
    async unassignSupportMail(requestParameters: UnassignSupportMailRequest): Promise<ObjectNoResponse> {
        const response = await this.unassignSupportMailRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderMailOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderMailCartsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportMailOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportMailCartsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
